import React from 'react';
import { DialogContent } from '@mui/material';

const ResponsiveDialogContent = ({ children }: React.PropsWithChildren<{}>) => {
  return <DialogContent>{children}</DialogContent>;
};

export default ResponsiveDialogContent;
